import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, Pipe, PipeTransform, SimpleChanges, ViewChild } from '@angular/core';
import { SectionData, RowCell, RichTextOptions } from '../../models/sections-model';

@Component({
  selector: 'kw-rich-text-renderer',
  templateUrl: './rich-text-renderer.component.html',
  styleUrls: ['./rich-text-renderer.component.scss']
})
export class RichTextRendererComponent implements OnInit,AfterViewInit,OnChanges {
  @Input() data:SectionData;
  @Input() title:string;
  cells:RowCell[];
  bgColor:string;

  richTextOptions:RichTextOptions;

  rendererType:string;
  heading:string;
  content:string;
  invert:boolean;
  headerSizeClass:string = "default";
  isMultiCell:boolean = false;

  wrapperClass:string;
  
  
  constructor() { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["data"]){
      console.log(this.data);
      this.richTextOptions = this.data["richTextOptions"];
      if(!this.data.wrapperClass){
        this.wrapperClass = "transparent";
        this.data.wrapperClass = "transparent";
      }else{
        this.wrapperClass = this.data.wrapperClass;
      }
      let rowCells = this.richTextOptions.rowCells;
      if(rowCells != undefined){
        this.cells = rowCells
      }
      if(this.data.bgColor != undefined){
        this.bgColor = this.data.bgColor;
      }
      console.log(this.content);
      this.rendererType = this.data.rendererType? this.data.rendererType : null;
      this.heading = this.data.heading? this.data.heading : null;
    
      this.invert = this.richTextOptions.invert? this.richTextOptions.invert : false;
      this.headerSizeClass = this.richTextOptions.headerSizeClass? this.richTextOptions.headerSizeClass : "default";
    }
  }
 

  ngOnInit(): void {
    console.log(this.data);
    this.richTextOptions = this.data["richTextOptions"];
    if(!this.data.wrapperClass){
      this.wrapperClass = "transparent";
      this.data.wrapperClass = "transparent";
    }else{
      this.wrapperClass = this.data.wrapperClass;
    }
    let rowCells = this.richTextOptions.rowCells;
    if(rowCells != undefined){
      this.cells = rowCells
    }
    if(this.data.bgColor != undefined){
      this.bgColor = this.data.bgColor;
    }
    /* let rowCell = this.richTextOptions.rowCells[0];
    if(rowCell["bannerText"] != undefined){
      this.content = rowCell["bannerText"];
    }else if(rowCell["contentElements"] != undefined){
      let contentElements:ContentElement[] = rowCell["contentElements"];
      if(contentElements != undefined){
        this.contentElement
      }
    } */
    
    console.log(this.content);
    this.rendererType = this.data.rendererType? this.data.rendererType : null;
    this.heading = this.data.heading? this.data.heading : null;
    //this.content = this.data.content? this.data.content : null;
    //this.invert = this.data.invert? this.data.invert : true;
    this.invert = this.richTextOptions.invert? this.richTextOptions.invert : false;
    this.headerSizeClass = this.richTextOptions.headerSizeClass? this.richTextOptions.headerSizeClass : "small";
  }

  ngAfterViewInit(): void {
    /* if(this.invert == true){
      this.wrapper.nativeElement.classList.add("invert");
      let host = <HTMLElement>this.wrapper.nativeElement;
      host.style.setProperty('--text-basic-color','--color-basic-200')
      
    } */
  }

}
